import React, { useState, useEffect } from 'react';
import { Button, Modal } from 'react-bootstrap';
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Select from 'react-select';

const AddDuration = ({ show, onClose, onSuccess }) => {    
  const baseURL = process.env.REACT_APP_API_BASE_URL;
  const [itemQuantityOptions, setItemQuantityOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const [durationName, setDurationName] = useState('');
  const [description, setDescription] = useState('');
  const [loading, setLoading] = useState(false);

  // For storing field-specific error messages
  const [errors, setErrors] = useState({});

  useEffect(() => {
    const fetchUnitsByCategory = async () => {
      try {
        const response = await axios.get(`${baseURL}/manageunit/by-category`, {
          params: { unit_category_sno: 5 },
        });

        if (response.data.success) {
          const options = response.data.data.map((unit) => ({
            value: unit.unit_name, // make sure this is sno for backend
            label: unit.unitslug_name,
          }));
          setItemQuantityOptions(options);
        } else {
          setItemQuantityOptions([]);
        }
      } catch (err) {
        console.error('Error fetching units:', err);
        setItemQuantityOptions([]);
      }
    };

    if (baseURL) {
      fetchUnitsByCategory();
    }
  }, [baseURL]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Clear previous errors
    setErrors({});

    let validationErrors = {};

    if (!durationName.trim()) {
      validationErrors.durationName = 'This field is required.';
    }

    if (!selectedOption) {
      validationErrors.unit = 'This field is required.';
    }

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setLoading(true);

    const payload = {
      duration_name: durationName.trim(),
      unit: selectedOption.value,
      description: description.trim() || null,
    };

    try {
      const res = await axios.post(`${baseURL}/duration`, payload, {
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (res.status === 201) {
        // Reset on success
        setDurationName('');
        setSelectedOption(null);
        setDescription('');
        onClose(); 
        if (onSuccess) onSuccess(); 
        toast.success("Duration Created successfully!");
      } else {
        setErrors({ general: 'Failed to create duration.' });
      }
    } catch (err) {
      if (err.response && err.response.data && err.response.data.errors) {
        const apiErrors = err.response.data.errors;
        const apiValidationErrors = {};

        if (apiErrors.duration_name) {
          apiValidationErrors.durationName = apiErrors.duration_name[0];
        }
        if (apiErrors.unit) {
          apiValidationErrors.unit = apiErrors.unit[0];
        }
        setErrors(apiValidationErrors);
      } else if (err.response && err.response.data && err.response.data.error) {
        setErrors({ general: err.response.data.error });
      } else {
        setErrors({ general: 'Failed to create duration.' });
      }
      console.error('API error:', err);
    } finally {
      setLoading(false); 
    }
  };

  return (
    <Modal show={show} size="md" onHide={onClose}>
      <form onSubmit={handleSubmit} noValidate>
        <div className="modal-content">
          <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
            <h3 className="modal-title text-white">Create Duration</h3>
            <Button variant="" type="button" className="close px-6 py-2" onClick={onClose}>
              <span className="text-white">×</span>
            </Button>
          </div>
          <div className="modal-body">
            {/* General error message */}
            {errors.general && (
              <div className="alert alert-danger" role="alert">
                {errors.general}
              </div>
            )}
            <div className="row">
              <div className="col-lg-6 mb-2">
                <label className="text-black font-w500 fs-7">
                  Duration<span className="required">*</span>
                </label>
                <input
                  type="text"
                  className={`form-control ${errors.durationName ? 'is-invalid' : ''}`}
                  placeholder="Enter Duration"
                  value={durationName}
                  onChange={(e) => setDurationName(e.target.value)}
                />
                {errors.durationName && (
                  <span className="text-danger fs-7">{errors.durationName}</span>
                )}
              </div>
              <div className="col-lg-6 mb-2">
                <label className="text-black font-w500 fs-7">
                  Unit<span className="required">*</span>
                </label>
                <Select
                  value={selectedOption}
                  onChange={setSelectedOption}
                  options={itemQuantityOptions}
                  placeholder="Select Units"
                  className={errors.unit ? 'is-invalid' : ''}
                />
                {errors.unit && (
                  <span className="text-danger fs-7">{errors.unit}</span>
                )}
              </div>
              <div className="col-lg-12 mb-2">
                <label className="text-black font-w500 fs-7">Description</label>
                <textarea
                  rows={8}
                  className="form-control"
                  placeholder="Description"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                />
              </div>
            </div>
            <div className="d-flex align-items-center justify-content-end gap-3 mt-4 mb-4">
              <Button type="submit" className="btn btn-sm btn-primary" disabled={loading}>
                {loading ? 'Creating...' : 'Create Duration'}
                <i className="fas fa-angle-double-right ms-2"></i>
              </Button>
            </div>
          </div>
        </div>
      </form>
    </Modal>
  );
};

export default AddDuration;
